import React from "react"
import PropTypes from "prop-types"

export const ProgressBar = ({ progress }) => (
  <aside className="progress">
    <span
      className="progress-bar"
      style={{ right: (1 - progress) * 100 + "%" }}
    ></span>
    <span className="hidden">{progress * 100 + "%"}</span>
  </aside>
)

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
}
